import React, { Fragment, ReactElement, useEffect, useState } from "react";
import { Column, Row } from "./FiltersCommon";
import styled from "styled-components";
import { TextBox } from "./valuelists/InputBoxes";
import { GenericButton, IconSettingsButton33x32 } from "../common/Buttons";
import { useTranslation } from "react-i18next";
import iconDialogClose from "../../../icons/IconDialogClose.png";
import iconDialogCloseHover from "../../../icons/IconDialogCloseHover.png";
import iconDialogClosePressed from "../../../icons/IconDialogClosePressed.png";

const DialogContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 101;
  padding: 20px;
  background: #ffffff;
  border: 2px solid #4eab00;
  box-sizing: border-box;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  width: 300px;
`;

const SaveDialogHeader = styled.div`
  color: #000000;
  margin-right: auto;
  line-height: 30px;
`;

const SaveButtonContainer = styled.div`
  margin-left: auto;
  margin-top: 12px;
`;

interface ISaveFilterButtonProps {
  filterName?: string;
  disabled: boolean;
  onSave: (filterName: string) => void;
}

export const SaveFilterButton = (props: ISaveFilterButtonProps): ReactElement => {
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [filterName, setFilterName] = useState<string>(props.filterName);

  useEffect(() => {
    setFilterName(props.filterName)
  }, [props.filterName] )

  const { t } = useTranslation();

  const saveFilter = () => {
    if (filterName !== "") {
      setSaveDialogOpen(false);
      props.onSave(filterName);
      setFilterName("");
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      saveFilter();
    }
  };

  const toggleSavePanel = () => {
    if (saveDialogOpen) {
      setSaveDialogOpen(false);
    } else {
      setSaveDialogOpen(true);
    }
  };

  return (
    <Fragment>

      <GenericButton disabled={props.disabled} onClick={() => setSaveDialogOpen(true)}>
        {t("filter.save")}
      </GenericButton>

      {saveDialogOpen && (
        <DialogContainer>
          <Column>

            <Row style={{ width: '100%' }}>
              <SaveDialogHeader>{t("filter.name")}</SaveDialogHeader>
              <IconSettingsButton33x32 
                style={{
                  alignSelf: 'flex-end'
                }}
                image={iconDialogClose} 
                imageHover={iconDialogCloseHover} 
                imagePressed={iconDialogClosePressed}
                onClick={toggleSavePanel}
              ></IconSettingsButton33x32>
            </Row>

            <TextBox 
              style={{ width: '100%', height: '36px' }} 
              value={filterName} 
              onChange={setFilterName} 
              onKeyPress={handleKeyPress} 
            />

            <SaveButtonContainer>
              <GenericButton onClick={saveFilter}>{t("command.save")}</GenericButton>
            </SaveButtonContainer>

          </Column>
        </DialogContainer>
      )}

    </Fragment>
  );
};
